export default __webpack_public_path__ + "static/media/scallops_thumb.834d23b0.jpg";